import React, { useEffect } from 'react';
import { Form, FormControl, Button} from 'react-bootstrap';
import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';

import './PinEditor.scss';
import { toast } from 'react-toastify';

const auth = new Auth();

const PinEditor = (props) => {
    const [isEditing, setIsEdting] = React.useState(false);  
    const [isAdd, setIsAdd] = React.useState(false);    
    const [isEdit, setIsEdit] = React.useState(false);   
         
    const [Id, setId] = React.useState("");    
    const [title, setTitle] = React.useState("");    
    const [url, setUrl] = React.useState("");  
    const [description, setDescription] = React.useState("");  
    const [target, setTarget] = React.useState(""); 
    const [caseNumber, setCaseNumber] = React.useState("");    
    const [collections, setCollections] = React.useState([]);   
    const [chosenCollection, setChosenCollection] = React.useState(0);         

    useEffect(() => {
        setTitle(props.title);
        setId(props.Id);
        setCaseNumber(props.case)
        setDescription(props.description);
        if(props.type === "add"){
            setIsAdd(true);
            getCollections();
        }

        if(props.type === "edit"){
            setIsEdit(true);
            getCollections();
            setId(props.editPin.Id);
            setTitle(props.editPin.Title);
            setUrl(props.editPin.Link);
            setDescription(props.editPin.Description);
            setTarget(props.editPin.Target)
            setChosenCollection(parseInt(props.editPin.CollectionId));
        }
    },[]);

    const getCollections = async () => {
        let accessToken = await auth.getToken();

        fetch(`/api/getUserPinCollections`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            
            data = data.filter(el => {
                if((el.isShared && el.isEditable) || el.isOwn){
                    return el;
                }
            } );
            data.unshift({Id: 0, CollectionName : "General Collection"});
            setCollections(data);           
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const updatePin = async () => {
        let accessToken = await auth.getToken();
        let pinData;
        if(target === "Custom"){
            pinData = {
                Id: Id,
                Title : title,
                Link : url,
                Description: description,
                CollectionId : parseInt(chosenCollection),
                CaseId : caseNumber
            };
        } else {
            pinData = {
                Id: Id,
                Title : title,
                Description: description,
                CollectionId : parseInt(chosenCollection),
                CaseId : caseNumber
            };
        }
        
        
        fetch(`/api/updatePin`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken                    
            },
            body : JSON.stringify(pinData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }]
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {
            props.updatePin(pinData);
            setIsEdting(false);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const addPin = async () => {
        let accessToken = await auth.getToken();

        let pinData = {
            Title : title,
            Link: url.indexOf("http") > -1 ? url : "https://" + url,
            Description: description,
            Target: "Custom",
            CollectionId : parseInt(chosenCollection)
        };
        
        fetch(`/api/addCustomPin`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken                    
            },
            body : JSON.stringify(pinData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {
            props.close();
            if(!data){
                toast("Pin already exists with name and url", {
                    position: "bottom-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true
                  });
                  return;
            }
            pinData.Id = data;
            props.addedPin(pinData);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    if(isAdd){
        return (
            <div id="pin-editor">
                <Form>
                    <label>Pin Name</label>
                    <Form.Control value={title} onChange={(e) => setTitle(e.target.value)}></Form.Control>
                    <label>Pin URL</label>
                    <Form.Control value={url} onChange={(e) => setUrl(e.target.value)}></Form.Control>
                    <label>Pin Description</label>
                    <Form.Control value={description} onChange={(e) => setDescription(e.target.value)}></Form.Control>
                    <label>Collection</label>
                    <Form.Control as="select" onChange={(e) => setChosenCollection(e.target.value)}>
                        {collections.map((item,index) =>
                            <option key={index} value={item.Id}>{item.CollectionName}</option>
                        )}
                    </Form.Control>
                    <Button className="float-right" onClick={() => {  props.close(); addPin();}} disabled={title === "" && url === ""}>Add</Button>
                </Form>
            </div>
       );
    }

    if(isEdit){
        return (
            <div id="pin-editor">
                <Form>
                    <label>Pin Name</label>
                    <Form.Control value={title} onChange={(e) => setTitle(e.target.value)}></Form.Control>
                    {target === "Custom" && (
                        <>
                        <label>Pin URL</label>
                        <Form.Control value={url} onChange={(e) => setUrl(e.target.value)}></Form.Control>
                        </>
                    )}
                    <label>Pin Description</label>
                    <Form.Control value={description} onChange={(e) => setDescription(e.target.value)}></Form.Control>
                    <label>Collection</label>
                    <Form.Control as="select" value={chosenCollection} onChange={(e) => setChosenCollection(e.target.value)}>
                        {collections.map((item,index) =>
                            <option key={index} value={item.Id}>{item.CollectionName}</option>
                        )}
                    </Form.Control>                   
                    <Button className="float-right" onClick={() => {  props.close(); updatePin();}}>Update</Button>
                </Form>
            </div>
       );
    }

    if(!isEditing){
        return (
            <div id="pin-editor">
                <p>Pinned</p>
                <p className="pinned-title">{title}</p> 
                <p style={{ color: "#565656" }}>Pinned to Case: {caseNumber}</p>
                <Button variant="link" onClick={() => { setIsEdting(true); props.edit(); getCollections();}}>Edit this pin</Button>
            </div>
        );
    }

    return (
        <div id="pin-editor">
            <Form>
                <label>Pin Name</label>
                <Form.Control value={title} onChange={(e) => setTitle(e.target.value)}></Form.Control>
                <label>Collection</label>
                <Form.Control as="select"  value={chosenCollection} onChange={(e) => setChosenCollection(e.target.value)}>
                    {collections.map((item,index) =>
                        <option key={index} value={item.Id}>{item.CollectionName}</option>
                    )}
                </Form.Control>
                <label>Case Number</label>
                <Form.Control value={caseNumber} onChange={(e) => setCaseNumber(e.target.value)}></Form.Control>
                <Button variant="link" className="float-right" onClick={() => {  props.close(); updatePin();}}>Update</Button>
            </Form>
        </div>
   );

}

export default PinEditor;
